import { useCurrentUser } from 'store/api/yay/user'
import {
  useGetCurrencyRateMutation,
  useWalletBagPreCreateMutation,
} from 'store/api/yay/misc'
import { useEffect, useState } from 'react'
import dayjs from 'dayjs'
import { CurrencyRate } from 'lib/_types'

export type BagEMPLDetailsResponse = {
  data: {
    empl: {
      locked: string
      unlocked: string
      total: string
    }
    exchangeRate?: CurrencyRate
    fetchTime: string
  }
  isLoading: boolean
  isSuccess: boolean
  isError: boolean
}

export const useEMPLDetails = (): BagEMPLDetailsResponse => {
  const { data: currentUser } = useCurrentUser()
  const [preCreateBag, preCreateBagRes] = useWalletBagPreCreateMutation()
  const [getCurrencyRate, getCurrencyRateRes] = useGetCurrencyRateMutation()

  const [empl, setEmpl] = useState({ locked: '', unlocked: '', total: '' })
  const [fetchTime, setFetchTime] = useState('')
  const [currencyRate, setCurrencyRate] = useState<CurrencyRate>()

  useEffect(() => {
    if (currentUser) {
      preCreateBag({})
      getCurrencyRate()
    }
  }, [currentUser])

  useEffect(() => {
    if (preCreateBagRes.isError) {
      setEmpl({ locked: '--', unlocked: '--', total: '--' })
      console.log(preCreateBagRes.error)
    }
  }, [preCreateBagRes])

  useEffect(() => {
    if (preCreateBagRes.isSuccess && preCreateBagRes.data) {
      setEmpl(preCreateBagRes.data?.result.empl)
    }
  }, [preCreateBagRes])

  useEffect(() => {
    if (getCurrencyRateRes.data) {
      setCurrencyRate(getCurrencyRateRes.data?.result['EMPL'])
    }
    setFetchTime(dayjs(getCurrencyRateRes.fulfilledTimeStamp).format('H:mm'))
  }, [getCurrencyRateRes])

  return {
    data: {
      empl: empl,
      fetchTime: fetchTime,
      exchangeRate: currencyRate,
    },
    isLoading: preCreateBagRes.isLoading || getCurrencyRateRes.isLoading,
    isSuccess: preCreateBagRes.isSuccess && getCurrencyRateRes.isSuccess,
    isError: preCreateBagRes.isError || getCurrencyRateRes.isError,
  }
}
